import type { CreatingModelComment, ModelCommentThreadRepository } from '../domain';
import type { ModelCommentContents } from '../domain/ModelCommentContents';
import { ModelCommentThreadRegionCollection } from '../domain';
import type { IPositionSetRepository } from '@view-model/models/common/PositionSet';
import type { CommandManager } from '@model-framework/command';
import { ModelCommentThreadCreateCommand } from '../command';
import type { SizeSet } from '@view-model/models/common/basic';
import type { Rect } from '@view-model/models/common/basic/Rect';
import type { ModelCommentThreadId } from 'balus-common';

export class ModelCommentOperation {
  constructor(
    private readonly threadRepository: ModelCommentThreadRepository,
    private readonly positionRepository: IPositionSetRepository,
    private readonly commandManager: CommandManager
  ) {}

  async createThread(creatingModelComment: CreatingModelComment): Promise<void> {
    const command = new ModelCommentThreadCreateCommand(
      creatingModelComment,
      this.threadRepository,
      this.positionRepository
    );
    this.commandManager.execute(command);
  }

  static getModelCommentThreadIdsByRect({
    rect,
    commentContents,
    commentSizeSet,
  }: {
    rect: Rect;
    commentContents: ModelCommentContents;
    commentSizeSet: SizeSet;
  }): ModelCommentThreadId[] {
    const regions = new ModelCommentThreadRegionCollection(
      commentContents.threads.list(),
      commentContents.positions,
      commentSizeSet
    );
    return regions.filterIdsBySelectionRect(rect);
  }
}
